import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    index: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "/missions/" + missionId + "/scheduled_events";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    cancel: async (missionId, scheduledEventId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/" + scheduledEventId + "/cancel";;

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },
}